module.exports = __webpack_public_path__ + "public/files/img/error.f000de8c.png";